import { React, useState, useRef, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { styled, Stack } from "@mui/material";
import { Dialog, Divider, makeStyles, Typography } from "@material-ui/core";
import textStyles from "../textStyles.module.css";
import DynamicAccordion from "../Accordion/DynamicAccordion.js";
import BayadCI from "./BayadCI.js";
import Address from "./Address.js";
import IdentificationDetails from "./IdentificationDetails.js";
import Buttons from "../Input/Buttons";
import  DynamicDialog  from "../../common/DynamicDialog/DynamicDialog";
import success from "../../../assets/icons/ic-success.svg";
import hourglass from "../../../assets/icons/ic-success.svg";
import warning from "../../../assets/icons/ic-warning.svg";

import { Container, Grid, Paper, withStyles, Avatar } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import {
	getRegistrationResult,
	setUserDetails,
	uploadDataToS3,
} from "../../../redux/modules/kycRegistration";
import { setTransactionType } from "../../../redux/modules/kycBayad";
import LoadingBar from "../Loading/LoadingBar.js";

const StyledStack = styled(Stack)(({ theme }) => ({
	margin: "10px",
}));

const StyledButtonStack = styled(Stack)(({ theme }) => ({
	display: "flex",
	flexFlow: "row",
	width: "100%",
	justifyContent: "flex-end",
}));

const StyledMarginStack = styled(Stack)(({ theme }) => ({
	display: "flex",
	width: "15%",
	margin: "5px",
}));

const StyledStackPadding = styled(Stack)(({ theme }) => ({
	padding: "20px",
}));

const stylingCancelButton = {
	backgroundColor: "#8B9095",
	borderColor: "#8B9095",
	color: "#FFF",
	margin: "0 auto",
	padding: "10px 38px",
	marginTop: "5%",
	marginBottom: "12%",
};

const stylingSubmitButton = {
	margin: "0 auto",
	padding: "10px 38px",
	marginTop: "5%",
	marginBottom: "12%",
};

const stylingSubmitDisabledButton = {
	opacity: "0.5",
	color: "#fff",
	backgroundColor: "#0068D1",
	margin: "0 auto",
	padding: "10px 38px",
	marginTop: "5%",
	marginBottom: "12%",
};

const stylingLoadingBox = {
	justifyContent: "center",
	flexFlow: "row",
	alignItems: "center",
};

const Register = (props) => {
	const { selectedTransaction } = props;
	const [bayadCIFields, setBayadCIFields] = useState({});
	const [permanentAddressFields, setPermanentAddressFields] = useState({});
	const [presentAddressFields, setPresentAddressFields] = useState({});
	const [identificationFields, setIdentificationCIFields] = useState({});
	const [btnDisabled, setBtnDisabled] = useState(true);
	const [submitHover, setSubmitHover] = useState(false);
	const [open, setOpen] = useState(false);
	const [confirm, setConfirm] = useState(false);
	const registrationResult = props.kycRegistration.userDetailsResult;
	const errorResult = props.kycRegistration.error.result;
	const isRegSuccess = props.kycRegistration.isSuccess;
	const isRegError = props.kycRegistration.isError;
	// const history = useHistory();
	// console.log(registrationResult)


	useEffect(() => {
		setBtnDisabled(false);
		btnDisabledChecker(bayadCIFields);
		btnDisabledChecker(permanentAddressFields);
		btnDisabledChecker(presentAddressFields);
		btnDisabledChecker(identificationFields);
	}, [
		bayadCIFields,
		permanentAddressFields,
		presentAddressFields,
		identificationFields,
		
	]);

	useEffect(()=>{
		setOpen(isRegSuccess||isRegError );
	}, [props.kycRegistration])

	const registrationResultMessage = {
		icon: registrationResult.hitStatus == "HIT"? hourglass : success,
		resultMessage: registrationResult.ResultMessage,
		primaryBtnLabel: registrationResult.hitStatus == "HIT" ? "Okay" : "Done",
		primaryBtnFunction: () => {
			window.location.href ="/bayad-id";
			handleClose()
		},
		hasSecondaryButton: false,
	};

	const registrationErrorMessage = {
		icon: warning,
		primaryBtnLabel:  "Okay" ,
	};
	
	const btnDisabledChecker = (inputObject) => {
		Object.values(inputObject).map((vals) => {
			if (
				vals.required == true &&
				(vals.fieldValue == "" || vals.fieldValue == null)
			) {
				setBtnDisabled(true);
			}
			if (
				vals.name == "mobileNumber" &&
				vals.fieldValue != "" &&
				vals.fieldValue != null &&
				vals.fieldValue.replace(/[^0-9]/g, "").length < 10
			) {
				setBtnDisabled(true);
			}
		});
	};
	
	let dispatch = useDispatch();
	const dataMerge = () => {
		let tempData = {};
		let idFileNames = [];
		Object.values(bayadCIFields).map((name) => {
			tempData = {
				...tempData,
				[name.name]:
					name.name == "mobileNumber"
						? name.fieldValue.replace(/[^0-9]/g, "")
						: name.fieldValue,
			};
		});
		Object.values(permanentAddressFields).map((name) => {
			tempData = { ...tempData, [name.dbname]: name.fieldValue };
		});
		Object.values(presentAddressFields).map((name) => {
			tempData = { ...tempData, [name.dbname]: name.fieldValue };
		});
		Object.values(identificationFields).map((name) => {
			if (name.type == "Attachment") {
				idFileNames = [...idFileNames, name.fieldValue];
			} else {
				tempData = {
					...tempData,
					id: { ...tempData.id, [name.name]: name.fieldValue },
				};
			}
		});
		tempData = {
			...tempData,
			id: { ...tempData.id, idFileNames },
		};
		dispatch(setUserDetails(tempData));
		dispatch(getRegistrationResult());
		dispatch(uploadDataToS3());
		console.log(props.kycRegistration.isSuccess)
		setOpen (props.kycRegistration.isSuccess)
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<>
			<LoadingBar
				loading={props.kycBayadLoading || props.kycRegistrationLoading}
				styleProps={stylingLoadingBox}
				thickness={3}
				size={100}
			/>
			<StyledStackPadding>
				<StyledStack>
					<p className={textStyles.textStylesBold1619WavehausBold}>
						Register KYC
					</p>
				</StyledStack>
				<StyledStack>
					<p className={textStyles.textStylesNormal1218Poppins}>
						Please ensure to input correct information from the
						customer.
					</p>
				</StyledStack>

				<form>
					<DynamicAccordion
						accordionSummary="Bayad Customer Information"
						defaultExpanded
					>
						<BayadCI
							setBayadCIFields={setBayadCIFields}
							submitHover={submitHover}
						/>
					</DynamicAccordion>

					<DynamicAccordion
						accordionSummary="Address"
						defaultExpanded
					>
						<Address
							setPermanentAddressFields={
								setPermanentAddressFields
							}
							setPresentAddressFields={setPresentAddressFields}
							submitHover={submitHover}
						/>
					</DynamicAccordion>

					<DynamicAccordion
						accordionSummary="Identification Details"
						defaultExpanded
					>
						<IdentificationDetails
							setIdentificationCIFields={
								setIdentificationCIFields
							}
							submitHover={submitHover}
						/>
					</DynamicAccordion>
					<StyledButtonStack>
						<StyledMarginStack>
							<Buttons
								variant="outlined"
								text="Cancel"
								styling={stylingCancelButton}
								handleOnClick={() => {
									dispatch(setTransactionType(""));
								}}
								radius={true}
								fullWidth
							/>
						</StyledMarginStack>
						<StyledMarginStack
							onMouseOver={() => {
								setSubmitHover(true);
							}}
							onMouseOut={() => setSubmitHover(false)}
						>
							<Buttons
								variant="contained"
								text="Submit"
								styling={
									btnDisabled
										? stylingSubmitDisabledButton
										: stylingSubmitButton
								}
								handleOnClick={() => dataMerge()}
								disabled={
									btnDisabled ||
									props.kycBayadLoading ||
									props.kycRegistrationLoading
								}
								radius={true}
								fullWidth
								// type="submit"
							/>
						</StyledMarginStack>
					</StyledButtonStack>
				</form>
				<DynamicDialog
					onCloseModal={handleClose}
					aria-labelledby="customized-dialog-title"
					isOpen={open}
					dialogEntry = {isRegSuccess? registrationResultMessage: registrationErrorMessage}
				>	
				</DynamicDialog>
			</StyledStackPadding>
		</>
	);
};

export default connect(
	(state) => ({
		userDetails: state.kycRegistration.userDetails,
		kycBayadLoading: state.kycBayad.loading,
		kycRegistrationLoading: state.kycRegistration.loading,
		kycRegistration: state.kycRegistration
	}),
	{
		getRegistrationResult,
		setUserDetails,
		setTransactionType,
		uploadDataToS3,
	}
)(Register);
